module.exports = __webpack_public_path__ + "a0ede40abdf30f8dcf03ca7aba0e7b2d.MP3";